




import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class SvgIcon extends Vue {
  @Prop({ type: String, required: true }) path!: string;

  private icon = "";
  private loading = true;

  private mounted() {
    (this.$api.download(this.path) as any)
      .then((icon: any) => (this.icon = icon))
      .finally(() => (this.loading = false));
  }
}
